module.exports = require( './lib/ldmlnum' );



// WEBPACK FOOTER //
// ./index.js